export const checkIsFunction: (fun?: () => void) => any = (fun) => {
  if (typeof fun === 'function') {
    try {
      return fun();
    } catch (error) {
      return undefined;
    }
  }
  return undefined;
};
